module.exports = __webpack_public_path__ + "img/dxf.0f861422.png";